import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/button/ActionButton';
import { InputIcon } from 'assets/materialIcons/materialIcons';

/**
 * A general button for linking within the CRM
 * @param linkTo
 * @param label
 * @param icon
 * @param style
 * @param history
 * @constructor
 */

const GeneralButton = (props) => {
    const { icon, label, linkTo, style, history } = props;
    let iconButton = <InputIcon />;

    if (icon !== 'undefined') {
        iconButton = icon;
    }

    const defaultButtonStyle = {
        textDecoration: 'none',
        display: 'inline-flex',
    };

    const buttonStyle = Object.assign({}, defaultButtonStyle, style);

    return (
        <Button
            title={ label }
            icon={ iconButton }
            onClick={ () => {
                history.push(linkTo);
            } }
            style={ buttonStyle }
        />
    );
};

GeneralButton.defaultProps = {
    label: 'Perform Action',
    linkTo: '',
    style: {
        overflow: 'inherit',
    },
};

GeneralButton.propTypes = {
    history: PropTypes.object,
    icon: PropTypes.object,
    label: PropTypes.string,
    linkTo: PropTypes.string,
    style: PropTypes.object,
};

export default GeneralButton;



// WEBPACK FOOTER //
// ./src/components/komparu/button/GeneralButton.js